import React, { useState, useEffect } from 'react'
import FormActionButtons from '../../../../../Shared/FormAction/FormActionButtons'
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Form, Schema } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import reinstatementService from '../../../../../../services/Public/Reinstatement/PE/peReinstatement.service';
import Issues from '../../../../../Shared/Card/Issues';
import LoadingSpinner from '../../../../../Shared/GenericComponents/LoadingSpinner';
import RedStar from '../../../../../Shared/GenericComponents/RedStar';

function AcknowledgementPage() {
    const push = useNavigate();
    const { StringType } = Schema.Types;
    const sectionId = 9;
    const routes = useSelector(x => x.currentRoutes);
    const reinstatementId = useSelector(x => x.currentApplicationId);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [formModel, setFormModel] = useState({})
    useEffect(() => {
        reinstatementService.peGetSection(reinstatementId, sectionId).then((response) => {
            setFormModel(response.data);
            setHasLoaded(true)
        })
    }, [])
    const model = Schema.Model({
        electronicSignature: StringType().isRequired('This field is required.')
    });

    const formSubmit = () => {
        reinstatementService.pePostSection(reinstatementId, sectionId, formModel.electronicSignature).then((response) => {
            if (response.data.id) {
                nextSectionNavigation()
            }
        })
    }
    const nextSectionNavigation = () => {
        push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route);
    }
    return (
        <div>
            <Container fluid>
                <Form readOnly={!formModel.isUserEditable} model={model} fluid formValue={formModel} onChange={formModel => setFormModel(formModel)} onSubmit={formSubmit}>
                    <b>Professional Engineer Reinstatement</b>
                    <h4 className="mb-3">Acknowledgement</h4>
                    {hasLoaded ?
                        <>
                            <Card>
                                <Card.Header><h6>Requirements/Information/Acknowledgement</h6></Card.Header>
                                <Card.Body>
                                    <p>I, the applicant named in this application, have read the contents hereof, and to the best of my knowledge, information and believe the statements and information in this application are true and correct in substance and effect and are made in good faith. I have not omitted any information requested in this application. I am aware that such an omission or untrue response may constitute fraud or deceit, material misstatement, perjury or the giving of false or forged evidence under Louisiana Revised Statutes 37:698 and 37:700. I understand and agree that any responses verifying my education, personal references, and experience shall be considered privileged and confidential and that this information was not reviewed by me nor will it be available for my inspection or review in the future.</p>
                                    <br/>
                                    <ul>
                                        <li>It is your responsibility to check your LOLA account frequently for any pending issues. Ensure you add "lapels.com" to your "Safe Senders" list in your email application and/or (if applicable) in your network firewall.</li>
                                        <li>Once we receive a complete application, with no pending issues, process time may take 6-8 weeks.  </li>
                                        <li>
                                            I certify that all information provided in this online reinstatement is true and correct to the best of my knowledge, information and belief.
                                        </li>
                                        <li>
                                            I am aware that an omission or untrue response may constitute fraud, deceit, material misstatement, perjury or the giving of false or forged evidence under Louisiana Revised Statutes 37:698 and 37:700
                                        </li>

                                        <li>
                                            <b className="colorRed">IMPORTANT: Payments are non-refundable.</b> If you believe that you will be reimbursed for your fee, verify this BEFORE proceeding further
                                        </li>
                                        <li>
                                            If you are unsure about getting reimbursed by your firm, please stop the application process here and come back after you verify. Your answers will be saved.
                                        </li>
                                    </ul>
                                    <hr />
                                    <Form.Group>
                                        <Row>
                                            <Col sm={4}>
                                                <Form.ControlLabel>
                                                    <h5>Electronic Signature of Applicant:<RedStar /></h5>
                                                    <span>(Type full name)</span>
                                                </Form.ControlLabel>
                                            </Col>
                                            <Col sm={8}><Form.Control name="electronicSignature" /></Col>
                                        </Row>
                                        <Form.HelpText className="d-none">Electronic Signature of Applicant</Form.HelpText>
                                    </Form.Group>
                                </Card.Body>
                            </Card>
                            <br />
                            <Issues isUserEditable={true} type={2} sectionId={formModel.id} /></> : <LoadingSpinner />
                    }

                    <FormActionButtons
                        backToSectionLink="/individual/peReinstatement/sections"
                        nextSectionCallback={nextSectionNavigation}
                        isReadOnly={!formModel.isUserEditable}
                    />
                </Form>
            </Container>
        </div>
    );
}
export default AcknowledgementPage